import Skeleton from 'components/3catinfo/Skeleton/Skeleton';
import styles from './destacatUltimaNoticia.module.scss';

const DestacatUltimaNoticiaSkeleton = (props) => {
    return (
        <div className={styles.notiDestacatUltimaNoti}>
            <section className={styles.cos}>
                <div className={styles.dataPublicacio}>
                    <span className={styles.punt}>&nbsp;</span>
                    <span className={styles.data}>
                        <Skeleton text width='80px' height='10px' />
                    </span>
                </div>
                <div className={styles.content}>
                    <div className={styles.contentTitol}>
                        <h3 className={styles.titol}>
                            <Skeleton titol num={2} />
                        </h3>
                    </div>
                    <div className={`${styles.contentImg} ${styles.contentImgSkeleton}`}>
                        <Skeleton imatge />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default DestacatUltimaNoticiaSkeleton;
